import { Anchor, Box, Button, CloseButton, Group, LoadingOverlay, Stack, Text } from "@mantine/core";
import useExternalApiService from "helpers/ExternalApiService";
import { ReactComponent as LocationIcon } from 'assets/location.svg';
import { ReactComponent as NavigationArrowIcon } from 'assets/navigationArrowRight.svg';
import { FC, useEffect, useState } from "react";

interface Props {
  placeId?: string;
  onClose?: () => void;
  onCreateLead: (leadInfo: any) => void;
  onCenterOnMap: (latLon: [number, number]) => void;
  onFindOnMap: (locationDetail: any) => void;
  onPhoneClicked: (phone: string) => void;
};
const apiUrl = process.env.REACT_APP_EAI_URL;

const LocationBaseballCard: FC<Props> = ({
  placeId,
  onClose,
  onCreateLead,
  onCenterOnMap,
  onFindOnMap,
  onPhoneClicked
}) => {
  const { postData } = useExternalApiService(apiUrl);
  const [locationDetails, setLocationDetails] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (placeId) {
      postData('/api/google_places_details', {
        place_id: placeId,
      }).then((response) => {
        setLocationDetails(response);
      }).finally(() => setIsLoading(false));
    }
    return () => {
      setIsLoading(true);
      setLocationDetails(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placeId]);

  return (
    <>
      <LoadingOverlay
        visible={isLoading}
        zIndex={1000}
      />
      <Box
        p={0}
        pt={40}
        w="100%"
        h="100%"
        pos="relative"
        style={{
          boxSizing: "border-box"
        }}>
        <Box
          c="#4F7D9C"
          fz="h3"
          fw="bold"
          pos="absolute"
          top={20}
          left={10}>
          Lead Information
        </Box>
        {onClose && (
          <CloseButton
            size="xl"
            pos="absolute"
            top={10}
            right={-10}
            onClick={onClose}
          />
        )}
        <Box pt={15}
          style={{ 
            position: "relative", 
            boxSizing: "border-box", 
            height: "100%",
            marginTop: "12px",
            borderTop: "1px solid #8B8B8B",
          }}>
          <Stack justify="space-between" h="95%">
            <Box>
              <Box pb={5} style={{
                borderBottom: "2px solid #F0F0F0"
              }}>
                <Text fw="bold" fz={20} my={5}>
                  {locationDetails?.place?.name}
                </Text>
                <Button 
                  my={5}
                  size="compact-xs" 
                  bg={locationDetails?.place?.current_opening_hours?.open_now ?
                    "#00DC49" : "#E64B37"
                  }>
                  {locationDetails?.place?.current_opening_hours?.open_now ?
                    "Open Now" : "Closed Now"}
                </Button>
                <Group justify="space-between" align="center" my={5}>
                  <Box maw={130}>
                    <Text fz={12}>
                      {locationDetails?.place?.formatted_address}
                    </Text>
                  </Box>
                  <Group align="center" c="#4F7D9C">
                    <Stack align="center" gap={5}
                      onClick={() => onCenterOnMap([
                        locationDetails?.place?.geometry?.location?.lat,
                        locationDetails?.place?.geometry?.location?.lng,
                      ])}>
                      <LocationIcon />
                      <Text fw="bold" fz={6}>
                        Center on Map
                      </Text>
                    </Stack>
                    <Stack align="center" gap={5}
                      onClick={() => onFindOnMap(locationDetails)}>
                      <NavigationArrowIcon />
                      <Text fw="bold" fz={6}>
                        Navigate
                      </Text>
                    </Stack>
                  </Group>
                </Group>
              </Box>
              <Box py={5} style={{
                borderBottom: "2px solid #F0F0F0"
              }}>
                <Text fz={16} fw="bold">
                  Phone
                </Text>
                <Text c="#4F7D9C" fw={18}
                  onClick={() => onPhoneClicked(
                    locationDetails?.place?.formatted_phone_number
                  )}>
                  {locationDetails?.place?.formatted_phone_number}
                </Text>
              </Box>
              <Box py={5} w="100%" pos="relative" style={{
                borderBottom: "2px solid #F0F0F0",
              }}>
                <Text fz={16} fw="bold">
                  Website
                </Text>
                <Anchor c="#4F7D9C" fw={18} target="_blank" truncate="end"
                  style={{
                    maxWidth: "320px",
                    display: "inline-block"
                  }}
                  href={locationDetails?.place?.website}>
                  {locationDetails?.place?.website}
                </Anchor>
              </Box>
              <Box py={5}>
                <Text fz={16} fw="bold">
                  Schedule
                </Text>
                <Box mt={8}>
                  {locationDetails?.place?.current_opening_hours?.weekday_text?.map(
                    (weekdayHours: string, index: number) => (
                      <Text key={index} fz={18}>
                        {weekdayHours}
                      </Text>
                    )
                  )}
                </Box>
              </Box>
            </Box>
            <Button
              bg="#4F7D9C"
              fullWidth
              style={{ boxSizing: "border-box" }}
              onClick={() => {
                onCreateLead(locationDetails);
              }}>
              CREATE LEAD
            </Button>
          </Stack>
        </Box>
      </Box>
    </>
  );
};

export default LocationBaseballCard;
